<p><img class="img-thumbnai rounded mx-auto d-block imgSize" src="assets/images/expireDate.svg" /></p>
<mat-dialog-actions align="center" class="dialog-actions">
    <div class="content" [ngClass]="{ rtl: isArabic() }">
        <div class="title">
            {{ 'sessionExpiredTitle' | translate }}
        </div>
        <div class="body main-message">
            {{ 'sessionExpiredMainBody' | translate }}
        </div>
        <div class="body error-message">
            {{ 'sessionExpiredErrorNote' | translate }}
        </div>
    </div>

    <button mat-button class="btn btn-coral" (click)="backToLogin()">
        {{ 'ok' | translate }}
    </button>
</mat-dialog-actions>
